

export const fetch = (u: string): string => "/career" + u

export default {
  fetch: fetch
}
